import router from 'next/router';
import React, { ReactElement, useCallback } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { requestContext } from '../../../common/requestContext';
import { getDataset } from '../../../common/shared/utils/getDataset';
import useTypedDispatch from '../../../common/useTypedDispatch';
import useTypedSelector from '../../../common/useTypedSelector';
import { Layout } from '../../../design-system/layout/Layout';
import { HelpFetcherHeadless } from '../../../domain/help/headless/HelpFetcherHeadless';
import { Help } from '../../../domain/help/presentational/Help';
import { setHelpId } from '../../../domain/help/state/helpSlice';
import { HelpQueryType } from '../../../domain/help/type';
import { getHelpUrl } from '../../../domain/help/util/getHelpUrl';
import { CommonMobileHeaderType } from '../../../header/constants';
import { LOG_CLICK_EVENT } from '../../../logging/logEvent';
function HelpPage() {
  const {
    isMobile,
    isWebView
  } = requestContext.requestInfo.display;
  const dispatch = useTypedDispatch();
  const {
    helpData,
    helpId,
    helpPage,
    totalCount
  } = useTypedSelector(state => state.help);
  const onClickHelp = useCallback((e: React.SyntheticEvent<HTMLElement, Event>) => {
    function handler() {
      const newId = getDataset(e.currentTarget, 'id');
      dispatch(setHelpId(newId));
      router.push(getHelpUrl({
        queryType: HelpQueryType.Id,
        queryValue: newId
      }), undefined, {
        scroll: false
      });
    }
    LOG_CLICK_EVENT('펼치기_클릭', e, handler);
  }, [dispatch]);
  const onChangePage = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!helpData || !helpPage) {
      return;
    }
    const newPage = Number(getDataset(e.currentTarget, 'page'));
    if (helpPage === newPage) {
      return;
    }
    router.push(getHelpUrl({
      queryType: HelpQueryType.Page,
      queryValue: newPage
    }), undefined, {
      scroll: false
    });
  }, [helpData, helpPage]);
  return <>
      <HelpFetcherHeadless>
        <Help helpData={helpData} helpId={helpId} helpPage={helpPage} totalCount={totalCount} isWebView={isWebView} isMobile={isMobile} onClickHelp={onClickHelp} onChangePage={onChangePage} />
        {helpId !== '' && helpPage !== 0 && <TrackPageViewContainer trackObj={{
        section: '더보기',
        page: '고객센터_도움말',
        actionType: 'Pageview',
        actionName: '도움말_화면',
        customProps: {
          user_action: 'pv'
        }
      }} />}
      </HelpFetcherHeadless>
    </>;
}
HelpPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_customer_help')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.FourDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default HelpPage;